<template>
	<div class="sub-values inline">
		<div class="sub-value">
			<div class="label">{{ label }}</div>
		</div>
	</div>
</template>

<script>
import {getLabel} from "@/helper/application/HomeOffice";

export default {

	props: {
		data: {
			type: Object,
			required: true,
		},
	},

	computed: {
		label ()
		{
			return getLabel(this.data.yesNo);
		}
	}
}
</script>
